<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Pending Application List</h3>
          
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
         
         <form role="form">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->

                    <div class="form-group">
                      <label>Select Branch <span class="red">*</span></label>
                      <select
                        v-model="form.branch_id"
                        name="branch_id"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('branch_id') }"
                      >
                        <option value="">ALL</option>
                        <option value="true">Agra</option>
                        <option value="false">Mathura</option>
                      </select>
                      <has-error :form="form" field="branch_id"></has-error>
                    </div>
                    <div class="form-group">
                      <button type="button" class="btn btn-success">
                        <i class="fa fa-eye"></i> GET RECORDS
                      </button>
                    </div>
                  </div>

                  <div class="col-sm-6"></div>
                </div>
              </form>
              
              <div class="table-responsive">
                <table class="table m-0">
                  <thead>
                    <tr>
                      <th>Member Code</th>
                      <th>Application No</th>

                      <th>Branch</th>
                      <th>Group Code</th>
                      <th>Group</th>
                      <th>Name</th>
                      <th>Employee</th>
                      <th>Product</th>
                      <th>Nominee</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>21000001</td>
                      <td>257</td>
                      <td>HEAD OFFICE</td>
                      <td>002001</td>
                      <td>Sanjay Palace</td>
                      <td>SAMEENA BEGAM</td>
                      <td>MEENA</td>
                      <td>PLAN 2 - (15000)</td>
                      <td>TEST1</td>
                      <td>1-Jan-2020</td>
                      <td>
                        <button class="btn btn-sm btn-primary">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
          
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Pending Application
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>


  
              
              
      <div class="modal fade" id="modal-xl">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Get Recovery Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="col-md-12">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <form role="form">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->

                          <div class="form-group">
                            <label
                              >Select Branch <span class="red">*</span></label
                            >
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                            >
                              <option value="">Select Branch</option>
                              <option value="true">Agra</option>
                              <option value="false">Mathura</option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Center <span class="red">*</span></label>
                            <select
                              v-model="form.center_id"
                              name="center_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('center_id'),
                              }"
                            >
                              <option value="">Select Center</option>
                              <option value="Addition">Sanjay Palace</option>
                              <option value="Deduction">Khandari</option>
                            </select>
                            <has-error
                              :form="form"
                              field="center_id"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!--/.col (right) -->
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-success">GET RECORDS</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      

</div>
</template>

<script>
export default {
  name: 'PendingApplication',
  data () {
    return {
      form: new Form({
        id: '',
        center_id: '',
        branch_id: '',
        member_id: '',
        member_name: '',
        loan_id: '',
        date: '',
        amount: '',
        status: false
      }),
      columns: [
        {
          label: 'MEMBER ID',
          field: 'member_id'
        },
        {
          label: 'MEMBER NAME',
          field: 'member_name'
        },

        {
          label: 'LOAN ID',
          field: 'loan_id'
        },

        {
          label: 'DATE',
          field: 'last_stallment_date'
        },

        {
          label: 'AMOUNT',
          field: 'amount'
        },

        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: [
        {
          id: 1,
          member_id: '3456',
          member_name: 'HOUSE RENT ALLOWNACE',
          load_id: '',
          last_stallment_date: '12/5/2020',
          amount: '2500'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// PendingApplications.vue?55e0d0b8